import SuperAdminLayout from "SuperAdmin/SuperAdminLayout/SuperAdminLayout"
import SettingsNav from "SuperAdmin/SuperAdminNav/SettingsNav"



const FooterSettings = () =>{
    return<>
    <SuperAdminLayout>

        <SettingsNav />

        <h1> Footer Settings</h1>


    </SuperAdminLayout>
    
    </>
}
export default FooterSettings